/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { carouselSlideStyle } from './styling';
import Pillar from '../Pillar';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useContext, useEffect, useState } from 'react';
import { DetailsContext } from '../../context/detailsContext';
import { CarouselContext } from '../../context/carouselContext';
import { TopicContext } from '../../context/topicContext';
import { durations, easings, colors } from '../../constants';
// import { mq } from '../../utils/mediaQuery';
import { tracking, tagType } from '../../utils/tracking';
import { messages as text } from '../../messages';

const CarouselSlide = (props) => {
  const {
    index,
    // messages,
    // nonUsersAgreePercent,
    overallPercent,
    // details,
    current,
    // isNext,
    // isPrev,
    color,
  } = props;

  const {
    viewDetails,
    setViewDetails,
    //  isFiltering,
    currentIndex,
  } = useContext(DetailsContext);
  const { isRotating, revealAnimationDone } = useContext(CarouselContext);
  const { setCurrentTopic, isNavigationOpen } = useContext(TopicContext);

  const [animateOut, setAnimateOut] = useState(false);
  // let opacityValue = 0;
  // let blurValue = 0;

  // const title = messages.charts[index].title;
  const title = <FormattedMessage id={`topic.topic${index + 1}NavTitle`} />;
  let shouldShowTitle = true;

  // let titleWidth = 100;

  // if (index === 1) {
  //   titleWidth = 50;
  // }
  // if (index === 2) {
  //   titleWidth = 60;
  // }
  // if (index === 5) {
  //   titleWidth = 35;
  // }
  // if (index === 6) {
  //   titleWidth = 70;
  // }

  if (viewDetails) {
    shouldShowTitle = false;
  }

  // if (isNext || isPrev) {
  //   opacityValue = viewDetails ? 0.4 : 1;
  //   blurValue = 1;
  // }

  // if (current) {
  //   opacityValue = isFiltering ? 0 : 1;
  // }

  useEffect(() => {
    if (viewDetails) {
      setAnimateOut(true);
      setCurrentTopic(currentIndex);
    } else {
      setTimeout(() => {
        setAnimateOut(false);
        setCurrentTopic(undefined);
      }, durations.scalePillarDuration + 100);
    }
  }, [viewDetails]);

  const slideProps = {
    'aria-label': 'Click to learn more',
    role: 'button',
    disabled: isRotating || !revealAnimationDone,
    css: [
      carouselSlideStyle,
      {
        filter: current && !isNavigationOpen ? `blur(0px)` : `blur(2px)`,
        pointerEvents: current ? 'auto' : 'none',
        opacity: viewDetails ? 0.4 : 1,
        transition: `opacity ${durations.carouselRotationDuration * 1.4}ms ${
          easings.viewDetailsOpacity
        }, filter ${durations.carouselRotationDuration}ms ${
          easings.viewDetailsOpacity
        }`,
      },
    ],
  };

  const handleClick = () => {
    tracking(
      tagType.event,
      text[`topic${currentIndex}Title`].defaultMessage,
      'CLICK',
      'In-page click',
    );
    setViewDetails(!viewDetails);
  };

  if (current) {
    slideProps.onClick = handleClick;
  }

  return (
    <button
      {...slideProps}
      style={{ pointerEvents: viewDetails ? 'none' : 'auto' }}>
      {/* <Pillar
        {...props}
        totalPercent={nonUsersAgreePercent}
        topPercent={details.allNonUsers.agreeCompletely}
        bottomPercent={details.allNonUsers.agree}
        hasScaledPillar
        color="green"
      /> */}
      <Pillar
        {...props}
        totalPercent={overallPercent * 5} // multiplying height because of low average percentages
        shownPercent={overallPercent} // but don't double percentage shown
        // topPercent={details.allUsers.agreeCompletely}
        // bottomPercent={details.allUsers.agree}
        hasScaledPillar
        color={color}
      />

      <h2
        css={{
          // display: 'none',
          // [mq('lg')]: {
          position: 'absolute !important',
          // bottom: -80,
          bottom: -70,
          lineHeight: '1.3 !important',
          color: `${colors.white} !important`,
          fontSize: '14px !important',
          padding: '0 !important',
          // display: 'block',
          // width: `calc(100% + ${titleWidth}px)`,
          width: 180,
          fontWeight: '600 !important',
          marginLeft: '50% !important',
          transform: 'translateX(-50%)',
          // textAlign: 'left',
          textAlign: 'center',
          willChange: 'opacity',
          transition: `opacity ${
            viewDetails ? 100 : durations.viewDetailsDuration
          }ms ${easings.viewDetailsOpacity}`,
          opacity: !shouldShowTitle ? 0 : animateOut ? 0 : 1,
          // },
        }}>
        {title}
      </h2>
    </button>
  );
};

CarouselSlide.propTypes = {
  // nonUsersAgreePercent: PropTypes.number,
  overallPercent: PropTypes.number,
  origWidthOfPillar: PropTypes.number,
  index: PropTypes.number,
  details: PropTypes.object,
  messages: PropTypes.object,
  current: PropTypes.bool,
  isNext: PropTypes.bool,
  isPrev: PropTypes.bool,
  color: PropTypes.string,
};

export default CarouselSlide;
